import { createTheme, type MantineColorsTuple } from "@mantine/core";

// BoxTechs brand orange (from the logo / boxtechs.com). #ff6c2f is the signature accent;
// index 6 is the default primary shade, index 7 the filled-hover.
const brand: MantineColorsTuple = [
  "#fff3ec",
  "#ffe0d0",
  "#ffbf9e",
  "#ff9d6c",
  "#ff8149",
  "#ff7233",
  "#ff6c2f",
  "#e85d1f",
  "#cc4f18",
  "#a83f12",
];

export const theme = createTheme({
  primaryColor: "brand",
  primaryShade: { light: 6 },
  defaultRadius: "md",
  fontFamily:
    '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
  headings: { fontWeight: "700" },
  colors: { brand },
});
